import { TableAssemblyParams } from './tableAssemblyParams';
import { PublicHttpService } from '../../../routes/teacher/public-http.service';
import { Component, OnInit, Injector, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { RespCodeEntityUtil } from 'src/app/routes/teacher/entity/respCodeEntityUtil';
import * as publicMethods from '@shared/utils/publicMethods';
import { TableAssemblyEnum } from '@shared/utils/tableAssemblyEnum';

@Component({
    selector: 'app-table-assembly',
    templateUrl: './table-assembly.component.html',
    styles: [],
})
export class TableAssemblyComponent extends PublicHttpService implements OnInit {
    // 参数信息
    @Input() public initParams: TableAssemblyParams;
    // 查询按钮触发器
    // tslint:disable-next-line: no-output-on-prefix
    @Output() private onFindPage = new EventEmitter<string>();
    // 列表加载完成触发器
    @Output() private supEnd = new EventEmitter<string>();
    // 行点击触发器
    @Output() private checkRow = new EventEmitter<string>();
    // 确定按钮触发器
    @Output() private supSave = new EventEmitter<string>();
    // 取消按钮触发器
    @Output() private supCancel = new EventEmitter<string>();
    // 列表数据
    datas: Array<any> = [];
    // 单选时选中的数据id
    public openid = '';
    // 单选时选中的数据名称
    public name = '';
    // 单选选中的数据
    public singleData: any;
    // 多选时选择的数据id集合
    public openids: Array<string> = [];
    // 多选时选择的数据名称集合
    public names: Array<string> = [];
    // 多选选中的数据
    public someDatas: Array<any>;
    // 多选时 双向数据绑定的名称  （names是数组双向数据绑定不更新）
    public checkNames = '';

    /**
     * 当前组件参数
     */
    public params: any = {
        name: '',
        // 用于查询时验证检索框的值是否发生变化
        oldName: '',
        visible: false,
        loading: false,
        total: 0,
        page: 1,
        rows: 10,
    };

    constructor(protected injector: Injector, private cdr: ChangeDetectorRef) {
        super(injector);
    }

    /**
     * 取消并关闭当前组件
     */
    cancelModel(): void {
        this.params.visible = false;
        this.init();
        this.supCancel.emit();
        this.params.name = '';
    }

    /**
     * 确定并关闭当前组件
     */
    saveModel(): void {
        if (!this.openid && this.openids.length <= 0) {
            this.message.create('warning', '请选择一条信息！');
            return;
        }
        this.params.visible = false;
        // 触发父组件的保存功能
        this.supSave.emit('选中了！');
        this.params.name = '';
    }

    /**
     * 初始化参数
     */
    init(): void {
        this.openid = '';
        this.name = '';
        this.openids = [];
        this.names = [];
        this.checkNames = '';
        this.params.name = '';
        this.params.oldName = '';
        this.params.total = 0;
        this.params.page = 1;
        this.params.rows = 10;
    }

    /**
     * 列表选中事件
     * @param openid 选中的数据id
     */
    tableClick(data: any): void {
        if (this.initParams.isSingle) {
            this.openid = data.openid;
            this.name = data.name;
            this.singleData = data;
            publicMethods.radioLine(data, this.datas, [data.openid]);
        } else {
            // 先对选中的数据进行操作
            publicMethods.multipleLines(data, this.openids);
            console.log(data);
            if (data.check && !this.names.includes(data.name)) {
                this.names.push(data.name);
            } else {
                const idx = this.names.indexOf(data.name);
                this.names.splice(idx, 1);
            }
            this.checkNames = this.names.toString();
            // 再对选中的名称进行操作
            //   if (data.check) {
            //     if (this.names.indexOf(data.name) === -1) {
            //       this.names.push(data.name);
            //       this.someDatas.push(data);
            //     }
            //   } else {
            //     if (this.names.indexOf(data.name) !== -1) {
            //       const index = this.names.indexOf(data.name);
            //       this.names.splice(index, 1);
            //     }
            //     if (this.someDatas.indexOf(data) !== -1) {
            //       const index = this.someDatas.indexOf(data);
            //       this.someDatas.splice(index, 1);
            //     }
            //   }

            //   if (this.names.length > 0) {
            //     this.name = this.names.join(',');
            //   } else {
            //     this.name = '';
            //   }
        }
        // 父组件触发点击事件
        this.checkRow.emit(data);
    }

    /**
     * 分页查询列表
     */
    findPage(par?: FormData, isEnd: boolean = false): void {
        if (par) {
            if (!par.has('name')) {
                par.append('name', this.params.name ? this.params.name : '');
            }
            if (!par.has('page')) {
                par.append('page', this.params.page);
            }
            if (!par.has('rows')) {
                par.append('rows', this.params.rows);
            }
        } else {
            par = publicMethods.generateFormData({
                name: this.params.name ? this.params.name : '',
                page: this.params.page,
                rows: this.params.rows,
            });
        }
        this.params.loading = true;
        this.http.post(this.initParams.url, par).subscribe((response: any) => {
            this.cdr.markForCheck();
            this.params.loading = false;
            if (response.err_msg) {
                this.message.create('error', response.err_msg);
                return;
            }
            if (!response.rows || response.rows.length <= 0) {
                if (this.params.page > 1) {
                    this.params.page = 1;
                    if (response.total > 0) {
                        this.findPage(par, isEnd);
                    }
                }
            }
            const arr = [];
            if (response.rows) {
                // tslint:disable-next-line: no-shadowed-variable
                response.rows.forEach((element: any) => {
                    if (this.initParams.title === TableAssemblyEnum.KCXX) {
                        const kc = this.getKcxx(element);
                        kc.xf = element.xf;
                        arr.push(kc);
                    } else if (this.initParams.title === TableAssemblyEnum.JXBXX) {
                        arr.push(new RespCodeEntityUtil(element.openid, element.kch, element.jxbmc));
                    } else if (this.initParams.title === TableAssemblyEnum.EXAMCLASS) {
                        arr.push(new RespCodeEntityUtil(element.openid, element.kch, element.ksbName));
                    } else if (this.initParams.title === TableAssemblyEnum.TEACHER) {
                        arr.push(new RespCodeEntityUtil(element.openid, element.gh, element.name));
                    } else if (this.initParams.title === TableAssemblyEnum.STUDENT) {
                        arr.push(new RespCodeEntityUtil(element.openid, element.xh, element.name));
                    } else if (this.initParams.title === TableAssemblyEnum.ROLE) {
                        arr.push(new RespCodeEntityUtil(element.openid, element.type, element.name));
                    } else {
                        arr.push(new RespCodeEntityUtil(element.openid, element.code, element.name));
                    }
                });
            }
            this.datas = arr;
            this.selectRow();
            this.params.total = response.total;
            this.cdr.detectChanges();
            // 触发列表加载完成事件
            if (this.initParams.isEnd || isEnd) {
                this.supEnd.emit();
            }
        });
    }

    // 如果选中的id有值则默认选中(一般在修改功能和分页多选时使用)
    selectRow(): void {
        if (this.openid || this.openids) {
            this.datas.forEach(element => {
                if (this.openid && element.openid === this.openid) {
                    publicMethods.radioLine(element, this.datas, [this.openid]);
                } else if (this.openids && this.openids.indexOf(element.openid) !== -1) {
                    publicMethods.multipleLines(element, this.datas, this.names);
                }
            });
        }
    }

    getKcxx(element: any): any {
        return new RespCodeEntityUtil(element.openid, element.kch, element.name);
    }

    sendHandler() {
        if (this.params.visible) {
            if (this.params.name !== this.params.oldName) {
                // 输入框的值发生了变化，初始化页码为第一页
                this.params.page = 1;
                // 更新原输入框的值
                this.params.oldName = this.params.name;
            }
            if (this.initParams.isSendFindPage) {
                this.onFindPage.emit('根据name查询列表');
            } else {
                this.findPage();
            }
        }
    }

    ngOnInit() {
    }
}
